/********************************************************************************
Filename: np-compare-symbol.js
Created: 06 Apr 2021
Author: Ron Robertson
Description: Displays "X", checkmark, dash
Usage Example:
<np-compare-symbol symbol="check"></np-compare-symbol>
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
            #np-compare-symbol{
                display:inline-block;
            }
            #check,
            #x,
            #dash{
                display:none;
                margin:0 auto;
            }

        </style>

        <div id="np-compare-symbol">
            <svg id="check" width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.185547 7L2.30687 4.87868L9.02464 11.4749L6.90332 13.5962L0.185547 7Z" fill="#1D1D16"/>
                <rect x="16.0957" y="0.282471" width="3" height="16" transform="rotate(45 16.0957 0.282471)" fill="#1D1D16"/>
            </svg>
            <svg id="x" width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.78125" y="2.40381" width="3" height="16" transform="rotate(-45 0.78125 2.40381)" fill="#1D1D16"/>
                <rect x="12.0957" y="0.282471" width="3" height="16" transform="rotate(45 12.0957 0.282471)" fill="#1D1D16"/>
            </svg>
            <svg id="dash" width="15" height="3" viewBox="0 0 15 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="15" height="3" fill="#1D1D16"/>
            </svg>
        </div><!--END np-compare-symbol-->
    `;

    class NpCompareSymbol extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            /* Use the Shadow DOM */
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            /* Reference to DOM Elements */
            this.check = this.shadowRoot.getElementById("check");
            this.x = this.shadowRoot.getElementById("x");
            this.dash = this.shadowRoot.getElementById("dash");

        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {

            /* Set default attribute value */
            if (!this.hasAttribute('symbol')) {
                this.setAttribute('symbol', "");
            }

        } /* END connectedCallback */

        /* Listen for when attributes change */
        /* attributes must be lowercase */
        static get observedAttributes() {
            return ['symbol'];
        }

      /* Called when attributes change */
      attributeChangedCallback(name, oldValue, newValue) {

        if(name === 'symbol' && newValue != oldValue) {

            /* Hide all symbols */
            this.check.style.display = "none";
            this.dash.style.display = "none";
            this.x.style.display = "none";

            /* Display the check symbol */
            if(newValue =='check'){
                this.check.style.display = "inline-block";

            /* Display the 'x' symbol */
            }else if(newValue=='x'){
                this.x.style.display = "inline-block";

            /* Display the dash symbol */
            }else if(newValue=='dash'){
                this.dash.style.display = "inline-block";
            }

        }
       }/* END attributesChangedCallback */

      /* Getting attributes */
      get symbol() {
        return this.getAttribute('symbol');
      }

      /* Settinng attributes */
      set symbol(newValue) {
        this.setAttribute('symbol', newValue);
      }

    } /* END class */

    window.customElements.define('np-compare-symbol', NpCompareSymbol);

  })();
